// Área do vistoriador: início, escolha do alojamento, competência/qual das 4, checklist, envio.
// Port de index.html:1246–1779. Mudanças: dados vêm da API, envio pela fila do aparelho
// (decisão 7.2), checklist vigente da API com cópia congelada (7.4), exige sessão com a
// permissão "vistoriar" (7.1).

import {
  anosDoVistoriador, calcularNota, classificar, congelarChecklist, erroDoAnexo, erroDoEnvio, pode, sugerirSemana,
  type ItemChecklist,
} from '../motor/index.js';
import type { CategoriaChecklistDTO, EnvioAnexo, EnvioVistoria, MesDoAlojamentoDTO, ObraDTO } from '../compartilhado/api.js';
import { api, carregarEu, ErroApi, euEmCache, getComCache } from './api.js';
import { adicionarNaFila, contarPendentes, enviarItem, enviarPendentes, sync, type ItemFila } from './fila.js';
import { dataUrlParaBlob, pickMultiplePhotos } from './fotos.js';
import { buildPDF, relatorioLocal } from './pdf.js';
import { COR_FORM, compTxt, esc, FUNDO_HOME, lsGet, lsSet, LOGO, MESES, toast } from './util.js';

/** Estado da tela (protótipo: S). */
export const S: any = { obra: null, aloj: null, statuses: {}, itemPhotos: {}, genPhotos: [], info: { auditor: '', addr: '', email: '' }, tab: 'dash', comp: null, semana: null, semanaManual: false, itens: [] as ItemChecklist[] };

export function hoje() {
  const e = euEmCache();
  if (e && e.hoje) return e.hoje;
  const d = new Date();
  return { ano: d.getFullYear(), mes: d.getMonth() + 1, dia: d.getDate() };
}

let _cadastro: ObraDTO[] = [];
let _checklist: CategoriaChecklistDTO[] = [];
let _mes: MesDoAlojamentoDTO | null = null;
export let _syncMsg = '';

function novoId(): string {
  try { if (crypto && (crypto as any).randomUUID) return (crypto as any).randomUUID(); } catch { /* sem randomUUID */ }
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) { const r = Math.random() * 16 | 0; return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16); });
}

// ── indicador de envio (tela de sucesso) ──
export async function syncText() {
  const p = await contarPendentes();
  if (p > 0) return { t: '⏳ ' + p + ' pendente(s) de envio', c: '#fbbf24' };
  if (sync.err) return { t: '⚠️ sem sincronizar', c: '#fca5a5' };
  if (sync.last) return { t: '✅ sincronizado ' + sync.last.toLocaleTimeString('pt-BR').slice(0, 5), c: '#86efac' };
  return { t: '… sincronizando', c: 'rgba(150,185,225,.7)' };
}
export function updateSyncUI() {
  try {
    const el2 = document.getElementById('sync-state');
    if (el2 && _syncMsg) el2.innerHTML = _syncMsg;
  } catch (e) { /* tela já trocou */ }
}

// HOME
export function renderHome() {
  try {
    const _m = document.getElementById('adm-menu'); if (_m) _m.remove();
    const _b = document.getElementById('adm-menu-bd'); if (_b) _b.remove();
    (window as any).pararAtualizacaoGestao && (window as any).pararAtualizacaoGestao();
  } catch (e) { /* nada a limpar */ }
  document.body.style.background = '#060e1a';
  document.body.style.overflow = 'hidden';
  (document.getElementById('app') || document.body).style.overflow = 'hidden';
  const _appEl = document.getElementById('app'); if (!_appEl) return;
  _appEl.innerHTML =
    '<div style="position:relative;min-height:100vh;display:flex;align-items:center;justify-content:center;padding:20px;overflow:hidden">'
    + '<div style="position:absolute;inset:0;background:radial-gradient(ellipse 70% 60% at 50% 55%,rgba(30,77,140,.3) 0%,transparent 70%);pointer-events:none"></div>'
    + '<img src="' + FUNDO_HOME + '" style="position:absolute;bottom:0;left:0;width:100%;height:auto;pointer-events:none;opacity:.9" alt="">'
    + '<div class="beam-wrap" style="position:relative;z-index:2;width:100%;max-width:min(420px,100%)">'
    + '<div class="home-inner">'
    + '<img src="' + LOGO + '" style="height:72px;object-fit:contain;margin-bottom:16px;filter:drop-shadow(0 4px 16px rgba(0,0,0,.5))">'
    + '<div style="font-size:clamp(22px,4.5vw,28px);font-weight:800;color:#fff;margin-bottom:6px;line-height:1.2">Vistoria de<br><span style="background:linear-gradient(135deg,#f0c060,#C9A84C);-webkit-background-clip:text;-webkit-text-fill-color:transparent;background-clip:text">Alojamento</span></div>'
    + '<div style="font-size:13px;color:rgba(180,200,230,.6);margin-bottom:26px;line-height:1.6">Realize a inspeção e gere o relatório PDF<br>ao final do checklist.</div>'
    + '<div style="height:1px;background:linear-gradient(to right,transparent,rgba(201,168,76,.35),transparent);margin-bottom:24px"></div>'
    + '<div style="display:flex;flex-direction:column;gap:12px">'
    + '<button onclick="showObras()" style="background:linear-gradient(135deg,#1a4a8a,#2E5C8A);border:1px solid rgba(255,255,255,.12);border-radius:16px;padding:18px 20px;color:#fff;cursor:pointer;font-family:inherit;text-align:left;display:flex;align-items:center;gap:15px;box-shadow:0 8px 28px rgba(46,92,138,.4),inset 0 1px 0 rgba(255,255,255,.1);width:100%">'
    + '<div style="background:rgba(255,255,255,.12);border:1px solid rgba(255,255,255,.15);border-radius:12px;width:48px;height:48px;display:flex;align-items:center;justify-content:center;font-size:22px;flex-shrink:0">🏠</div>'
    + '<div style="flex:1"><div style="font-size:16px;font-weight:800;margin-bottom:2px">Iniciar vistoria</div><div style="font-size:12px;color:rgba(184,212,240,.75)">39 itens — 5 categorias</div></div>'
    + '<span style="color:rgba(255,255,255,.35);font-size:20px">›</span></button>'
    + '<button onclick="showAdminLogin()" style="background:rgba(255,255,255,.04);border:1px solid rgba(255,255,255,.1);border-radius:16px;padding:18px 20px;color:#fff;cursor:pointer;font-family:inherit;text-align:left;display:flex;align-items:center;gap:15px;box-shadow:0 4px 16px rgba(0,0,0,.3),inset 0 1px 0 rgba(255,255,255,.06);width:100%">'
    + '<div style="background:rgba(201,168,76,.12);border:1px solid rgba(201,168,76,.25);border-radius:12px;width:48px;height:48px;display:flex;align-items:center;justify-content:center;font-size:22px;flex-shrink:0">🔐</div>'
    + '<div style="flex:1"><div style="font-size:16px;font-weight:800;margin-bottom:2px">Área de gestão</div><div style="font-size:12px;color:rgba(180,200,230,.5)">Acesso restrito — apenas admins</div></div>'
    + '<span style="color:rgba(255,255,255,.25);font-size:20px">›</span></button>'
    + '</div>'
    + '<div style="margin-top:24px;font-size:10px;font-weight:700;letter-spacing:3px;color:#C9A84C;opacity:.75;text-transform:uppercase">LBX · VISTORIA DE ALOJAMENTOS</div>'
    + '<button id="pwa-install-btn" onclick="installPWA()" style="display:none;margin-top:16px;background:rgba(201,168,76,.15);border:1px solid rgba(201,168,76,.4);border-radius:12px;padding:10px 20px;color:#C9A84C;cursor:pointer;font-family:inherit;font-size:13px;font-weight:700;align-items:center;gap:8px;width:100%;justify-content:center">📲 Instalar app na tela inicial</button>'
    + '</div></div></div>';
}

/** Sessão para vistoriar. Sem rede, usa a última sessão conhecida (o envio vai para a fila). */
async function garantirVistoriador(): Promise<boolean> {
  let e: any = null;
  try { e = await carregarEu(); } catch (err: any) {
    if (err instanceof ErroApi && err.status === 401) return false; // já redirecionou para o login
    e = euEmCache();
  }
  if (!e) { toast('⚠️ Sem conexão. Abra o app com internet uma vez para entrar.', 'error'); return false; }
  if (!pode(e, 'vistoriar')) { toast('🔒 Seu acesso não permite fazer vistorias. Peça a liberação ao gestor.', 'error'); return false; }
  return true;
}

// OBRAS
export async function showObras() {
  document.body.style.overflow = '';
  (document.getElementById('app') || document.body).style.overflow = 'auto';
  const c = lsGet('cache_cadastro');
  if (c) { _cadastro = c; renderObras(); }
  if (!(await garantirVistoriador())) { if (c) renderHome(); return; }
  try {
    const antes = JSON.stringify(_cadastro);
    _cadastro = await getComCache<ObraDTO[]>('/api/cadastro', 'cadastro');
    if (!c || antes !== JSON.stringify(_cadastro)) renderObras();
  } catch (e: any) {
    if (!c) toast('⚠️ Não foi possível carregar as obras: ' + e.message, 'error');
  }
  getComCache<CategoriaChecklistDTO[]>('/api/checklist', 'checklist').then(function (k) { _checklist = k; }).catch(function () { /* usa o cache */ });
}
function q(s: string) { return esc(String(s).replace(/\\/g, '\\\\').replace(/'/g, "\\'")); }
export function renderObras() {
  const obras = _cadastro;
  let html = '';
  if (!obras.length) { html = '<div style="color:rgba(180,200,230,.5);text-align:center;padding:40px;font-size:14px">Nenhuma obra cadastrada.</div>'; }
  else {
    obras.forEach(function (ob) {
      const als = ob.alojamentos || [];
      let rows = als.map(function (al) {
        return '<div class="aloj-row" onclick="pickAloj(\'' + q(ob.id) + '\',\'' + q(al.id) + '\')">' +
          '<div><div style="color:rgba(200,220,248,.9);font-size:14px;font-weight:600">📍 ' + esc(al.nome) + '</div>' +
          '<div style="color:rgba(140,170,210,.55);font-size:12px;margin-top:2px">👤 ' + esc(al.responsavel || 'Sem responsável') + '</div></div>' +
          '<span style="color:rgba(255,255,255,.25);font-size:16px">›</span></div>';
      }).join('');
      if (!rows) rows = '<div style="padding:10px 18px;color:rgba(140,170,210,.4);font-size:13px">Nenhum alojamento cadastrado</div>';
      html += '<div class="obra-card"><div class="obra-head"><span style="font-size:18px">🏗️</span><span style="font-weight:800;color:#fff;font-size:15px">' + esc(ob.nome) + '</span></div>' + rows + '</div>';
    });
  }
  document.body.style.overflow = ''; (document.getElementById('app') || document.body).style.overflow = 'auto';
  (document.getElementById('app') as HTMLElement).innerHTML =
    '<div style="background:#060e1a;min-height:100vh">'
    + '<div class="fhdr"><button class="fhdr-back" onclick="renderHome()">←</button><div><div style="font-weight:800;font-size:15px">Selecionar alojamento</div><div style="font-size:10px;color:rgba(150,185,225,.5);letter-spacing:.5px;text-transform:uppercase">LBX Vistoria</div></div></div>'
    + '<div class="pb" style="padding-bottom:20px"><div style="color:rgba(180,200,230,.6);font-size:13px;margin-bottom:14px">Selecione pelo nome do responsável:</div>' + html + '</div></div>';
}

export function pickAloj(obraId: string, alojId: string) {
  const ob = _cadastro.find(function (o) { return o.id === obraId; });
  const al = ob && ob.alojamentos.find(function (a) { return a.id === alojId; });
  if (!ob || !al) return;
  S.obra = { id: ob.id, name: ob.nome };
  S.aloj = { id: al.id, name: al.nome, resp: al.responsavel || '' };
  S.statuses = {}; S.itemPhotos = {}; S.genPhotos = [];
  S.semana = null; S.semanaManual = false;
  const e = euEmCache();
  S.info = { auditor: al.responsavel || '', addr: al.nome, email: lsGet('lastEmail') || (e && e.email) || '' };
  showCompetenciaScreen();
}

async function carregarMes() {
  const comp = compTxt(S.comp);
  const chave = 'mes_' + S.aloj.id + '_' + comp;
  try {
    _mes = await api<MesDoAlojamentoDTO>('GET', '/api/alojamentos/' + encodeURIComponent(S.aloj.id) + '/mes?comp=' + comp);
    lsSet('cache_' + chave, _mes);
  } catch (e: any) {
    if (e instanceof ErroApi && e.status === 401) throw e;
    _mes = lsGet('cache_' + chave);
    if (!_mes) toast('⚠️ Sem conexão: progresso do mês indisponível', 'error');
  }
}

export async function showCompetenciaScreen() {
  if (!S.comp) { const h = hoje(); S.comp = { ano: h.ano, mes: h.mes }; }
  try { await carregarMes(); } catch { return; }
  renderCompetencia();
}

function renderCompetencia() {
  const compAtiva = MESES[S.comp.mes - 1] + '/' + S.comp.ano;
  const m: any = _mes || { feitas: 0, faltam: 4, aprovadas: 0, aguardando: 0, reprovadas: [], completo: false, porSemana: {}, anos: null };
  const feitas = m.feitas, faltam = m.faltam, nAprov = m.aprovadas, nEspera = m.aguardando;
  const rejectedSubs: any[] = m.reprovadas || [];
  const porSem: any = m.porSemana || {};

  const mesSel = MESES[S.comp.mes - 1], anoSel = S.comp.ano;
  const anos: number[] = m.anos || anosDoVistoriador(hoje(), anoSel);
  const optMes = MESES.map(function (mm) { return '<option value="' + mm + '" style="background:#1a3a70;color:#fff"' + (mm === mesSel ? ' selected' : '') + '>' + mm + '</option>'; }).join('');
  const optAno = anos.map(function (y) { return '<option value="' + y + '" style="background:#1a3a70;color:#fff"' + (y === anoSel ? ' selected' : '') + '>' + y + '</option>'; }).join('');

  let rejectHtml = '';
  if (rejectedSubs.length > 0) {
    rejectHtml = '<div style="background:rgba(220,38,38,.12);border:1.5px solid rgba(220,38,38,.4);border-radius:16px;padding:16px 20px;margin-bottom:14px">'
      + '<div style="font-size:13px;font-weight:800;color:#ef4444;margin-bottom:10px">⚠️ ' + rejectedSubs.length + ' vistoria(s) reprovada(s) em ' + esc(compAtiva) + ' — precisa refazer</div>';
    rejectedSubs.slice(0, 4).forEach(function (s) {
      rejectHtml += '<div style="background:rgba(0,0,0,.2);border-radius:10px;padding:10px 14px;margin-bottom:8px">'
        + '<div style="font-size:12px;color:rgba(200,220,248,.7);margin-bottom:4px">' + (s.semana ? s.semana + 'ª vistoria — ' : '') + new Date(s.enviadaEm).toLocaleDateString('pt-BR') + '</div>'
        + '<div style="font-size:13px;font-weight:700;color:#fca5a5">Motivo: ' + esc(s.motivoReprovacao || 'não informado') + '</div>'
        + '</div>';
    });
    rejectHtml += '</div>';
  }

  // pré-seleção de qual das 4 (comportamento de tela; motor só para escolher a bolinha)
  S.semana = sugerirSemana({ porSemana: porSem } as any, S.semana, S.semanaManual);
  const CORES: any = {
    approved: { b: '#16a34a', f: 'rgba(22,163,74,.18)', c: '#22c55e', i: '✓', t: 'Aprovada' },
    rejected: { b: '#dc2626', f: 'rgba(220,38,38,.18)', c: '#f87171', i: '✕', t: 'Reprovada' },
    pending: { b: '#d97706', f: 'rgba(217,119,6,.15)', c: '#fbbf24', i: '⏳', t: 'Aguardando aprovação' },
  };
  function corDe(s: any) { return CORES[(s && s.status === 'aprovada') ? 'approved' : (s && s.status === 'reprovada') ? 'rejected' : 'pending']; }
  const dots = [1, 2, 3, 4].map(function (n) {
    const s = porSem[n], sel = (S.semana === n);
    const e = s ? corDe(s) : { b: 'rgba(255,255,255,.18)', f: 'rgba(255,255,255,.05)', c: 'rgba(200,220,248,.55)', i: String(n), t: 'Não enviada' };
    return '<button onclick="escolherSemana(' + n + ')" title="' + e.t + '" style="background:none;border:none;padding:0;cursor:pointer;font-family:inherit;display:flex;flex-direction:column;align-items:center;gap:4px">'
      + '<div style="width:52px;height:52px;border-radius:50%;display:flex;align-items:center;justify-content:center;font-size:16px;font-weight:800;border:2.5px solid ' + e.b + ';background:' + e.f + ';color:' + e.c + ';box-shadow:' + (sel ? '0 0 0 3px rgba(201,168,76,.55)' : 'none') + '">' + (s ? e.i : n) + '</div>'
      + '<div style="font-size:10px;font-weight:700;color:' + e.c + '">' + n + 'ª</div>'
      + '</button>';
  }).join('');
  const legenda = '<div style="display:flex;justify-content:center;gap:12px;flex-wrap:wrap;font-size:10px;font-weight:700;margin-bottom:10px">'
    + '<span style="color:#22c55e">● Aprovada</span>'
    + '<span style="color:#fbbf24">● Aguardando</span>'
    + '<span style="color:#f87171">● Reprovada</span>'
    + '<span style="color:rgba(200,220,248,.45)">● Não enviada</span>'
    + '</div>';
  const sSel = porSem[S.semana]; let boxSel = '';
  if (sSel) {
    const eSel = corDe(sSel);
    boxSel = '<div style="background:' + eSel.f + ';border:1.5px solid ' + eSel.b + ';border-radius:12px;padding:12px 14px;margin-bottom:14px">'
      + '<div style="font-size:13px;font-weight:800;color:' + eSel.c + '">' + eSel.i + ' ' + S.semana + 'ª vistoria — ' + eSel.t + '</div>'
      + '<div style="font-size:11px;color:rgba(200,220,248,.7);margin-top:3px">Enviada em ' + new Date(sSel.enviadaEm).toLocaleDateString('pt-BR')
      + (typeof sSel.nota === 'number' ? ' · ' + sSel.nota.toFixed(1) + '%' : '') + (sSel.tipo === 'anexo' ? ' · 📎 anexada' : '') + '</div>'
      + (sSel.status === 'reprovada'
        ? '<div style="background:rgba(0,0,0,.25);border-radius:8px;padding:9px 12px;margin-top:8px;font-size:12px;color:#fca5a5;font-weight:700">Motivo da reprovação: ' + esc(sSel.motivoReprovacao || 'não informado') + '</div>'
        + '<div style="font-size:11px;color:rgba(200,220,248,.7);margin-top:6px">Refaça esta vistoria corrigindo o apontamento.</div>'
        : '')
      + '</div>';
  }
  const nItens = (_checklist.length ? congelarChecklist(_checklist) : (lsGet('cache_checklist') ? congelarChecklist(lsGet('cache_checklist')) : [])).length || 39;

  (document.getElementById('app') as HTMLElement).innerHTML =
    '<div style="background:#060e1a;min-height:100vh">'
    + '<div class="fhdr"><button class="fhdr-back" onclick="showObras()">←</button>'
    + '<div><div style="font-weight:800;font-size:14px">' + esc(S.aloj.name) + '</div>'
    + '<div style="font-size:10px;color:rgba(150,185,225,.5);text-transform:uppercase;letter-spacing:.4px">' + esc(S.obra.name) + '</div>'
    + '</div></div>'
    + '<div style="padding:20px;max-width:500px;margin:0 auto">'
    + rejectHtml
    + '<div style="background:rgba(12,24,48,.8);border:1px solid rgba(255,255,255,.1);border-radius:16px;padding:20px;margin-bottom:16px;backdrop-filter:blur(12px)">'
    + '<div style="display:flex;align-items:center;gap:8px;margin-bottom:16px">'
    + '<div style="background:rgba(46,92,138,.3);border:1px solid rgba(46,92,138,.5);border-radius:8px;width:32px;height:32px;display:flex;align-items:center;justify-content:center;font-size:16px">📊</div>'
    + '<div><div style="font-size:13px;font-weight:700;color:#fff">Progresso do mês</div>'
    + '<div style="font-size:11px;color:rgba(140,170,210,.6)">' + esc(compAtiva) + '</div></div>'
    + '</div>'
    + '<div style="font-size:12px;font-weight:700;color:rgba(200,220,248,.75);margin-bottom:10px">Qual das 4 vistorias você vai fazer?</div>'
    + '<div style="display:flex;justify-content:space-around;margin-bottom:10px">' + dots + '</div>'
    + legenda
    + '<div style="font-size:11px;color:rgba(140,170,210,.6);text-align:center;margin-bottom:14px">Selecionada: <strong style="color:#f0c060">' + S.semana + 'ª vistoria</strong></div>'
    + boxSel
    + '<div style="background:rgba(255,255,255,.06);border-radius:10px;padding:12px 16px;display:flex;justify-content:space-between;align-items:center">'
    + '<div><div style="font-size:13px;color:rgba(200,220,248,.8);font-weight:600">Vistorias enviadas</div>'
    + '<div style="font-size:24px;font-weight:900;color:' + (feitas >= 4 ? '#16a34a' : feitas > 0 ? '#d97706' : '#dc2626') + '">' + feitas + ' / 4</div>'
    + '<div style="font-size:11px;font-weight:700;margin-top:2px"><span style="color:#22c55e">' + nAprov + ' aprovada(s)</span>'
    + '<span style="color:rgba(140,170,210,.5)"> · </span><span style="color:#fbbf24">' + nEspera + ' aguardando</span>'
    + (rejectedSubs.length ? '<span style="color:rgba(140,170,210,.5)"> · </span><span style="color:#f87171">' + rejectedSubs.length + ' reprovada(s)</span>' : '')
    + '</div></div>'
    + '<div style="text-align:right"><div style="font-size:13px;color:rgba(200,220,248,.8);font-weight:600">Faltam</div>'
    + '<div style="font-size:24px;font-weight:900;color:' + (faltam === 0 ? '#16a34a' : '#C9A84C') + '">' + faltam + '</div></div>'
    + '</div>'
    + (feitas >= 4 ? '<div style="margin-top:12px;background:rgba(22,163,74,.15);border:1px solid rgba(22,163,74,.3);border-radius:10px;padding:10px 14px;font-size:13px;color:#22c55e;font-weight:600;text-align:center">✅ Mês completo! Você já enviou as 4 vistorias.</div>' : '')
    + '</div>'
    + '<div style="background:rgba(12,24,48,.8);border:1px solid rgba(255,255,255,.1);border-radius:16px;padding:20px;margin-bottom:16px;backdrop-filter:blur(12px)">'
    + '<div style="display:flex;align-items:center;gap:8px;margin-bottom:14px">'
    + '<div style="background:rgba(201,168,76,.15);border:1px solid rgba(201,168,76,.3);border-radius:8px;width:32px;height:32px;display:flex;align-items:center;justify-content:center;font-size:16px">📅</div>'
    + '<div><div style="font-size:13px;font-weight:700;color:#fff">Competência desta vistoria</div>'
    + '<div style="font-size:11px;color:rgba(140,170,210,.6)">Escolha o mês e o ano de referência</div></div>'
    + '</div>'
    + '<div style="display:grid;grid-template-columns:1.4fr 1fr;gap:10px">'
    + '<select id="comp-mes" onchange="mudarComp()" style="width:100%;padding:13px 16px;border:1.5px solid rgba(255,255,255,.12);border-radius:12px;font-size:15px;font-weight:700;color:#fff;outline:none;cursor:pointer;background:rgba(255,255,255,.08);-webkit-appearance:none;appearance:none">' + optMes + '</select>'
    + '<select id="comp-ano" onchange="mudarComp()" style="width:100%;padding:13px 16px;border:1.5px solid rgba(255,255,255,.12);border-radius:12px;font-size:15px;font-weight:700;color:#fff;outline:none;cursor:pointer;background:rgba(255,255,255,.08);-webkit-appearance:none;appearance:none">' + optAno + '</select>'
    + '</div>'
    + '<div style="font-size:12px;color:rgba(201,168,76,.7);margin-top:10px;display:flex;align-items:center;gap:6px">⚠️ Verifique antes de iniciar — não é possível alterar depois.</div>'
    + '</div>'
    + '<button onclick="iniciarVistoria()" style="width:100%;background:linear-gradient(135deg,#1a3a70,#2E5C8A);border:none;border-radius:14px;padding:18px 20px;color:#fff;cursor:pointer;font-family:inherit;text-align:left;display:flex;align-items:center;gap:14px;box-shadow:0 6px 20px rgba(31,56,100,.4)">'
    + '<span style="font-size:24px">📋</span>'
    + '<div><div style="font-size:16px;font-weight:800">Iniciar vistoria</div>'
    + '<div style="font-size:12px;color:rgba(200,220,248,.7)">' + nItens + ' itens — 5 categorias</div></div>'
    + '<span style="margin-left:auto;font-size:20px;color:rgba(255,255,255,.3)">›</span>'
    + '</button>'
    + '<button onclick="anexarVistoria()" style="width:100%;margin-top:10px;background:rgba(255,255,255,.05);border:1px solid rgba(255,255,255,.14);border-radius:14px;padding:16px 20px;color:#fff;cursor:pointer;font-family:inherit;text-align:left;display:flex;align-items:center;gap:14px">'
    + '<span style="font-size:22px">📎</span>'
    + '<div><div style="font-size:15px;font-weight:800">Anexar vistoria já feita</div>'
    + '<div style="font-size:12px;color:rgba(180,200,230,.6)">Envie o PDF que baixou e não apareceu no sistema</div></div>'
    + '<span style="margin-left:auto;font-size:18px;color:rgba(255,255,255,.3)">›</span>'
    + '</button>'
    + '</div></div>';
}

export function escolherSemana(n: number) {
  const s: any = _mes && (_mes.porSemana as any)[n];
  if (s && s.status !== 'reprovada' && s.semana === n) {
    const jaAprov = s.status === 'aprovada';
    if (!confirm('A ' + n + 'ª vistoria desta competência ' + (jaAprov ? 'já foi aprovada' : 'já foi enviada e está aguardando aprovação') + '. Deseja enviar outra mesmo assim?')) return;
  }
  S.semana = n; S.semanaManual = true;
  renderCompetencia();
}

// ── Anexar vistoria feita fora do sistema ──────────────────────────────────
export function anexarVistoria() {
  const inp = document.createElement('input');
  inp.type = 'file'; inp.accept = 'application/pdf,image/*'; inp.style.display = 'none';
  inp.onchange = function () {
    const f = inp.files && inp.files[0];
    inp.remove();
    if (!f) return;
    const erro = erroDoAnexo(f.size);
    if (erro) { alert(erro); return; }
    salvarAnexo(f);
  };
  document.body.appendChild(inp); inp.click();
}
function salvarAnexo(f: File) {
  const dados: EnvioAnexo = {
    idCliente: novoId(), alojId: S.aloj.id, competencia: compTxt(S.comp), semana: S.semana || null,
    auditor: S.info.auditor || S.aloj.resp || '', email: S.info.email || '', feitaEm: new Date().toISOString(),
  };
  const item: ItemFila = { idCliente: dados.idCliente, rota: '/api/vistorias/anexo', dados, arquivos: [{ campo: 'arquivo', blob: f, nome: f.name || 'vistoria.pdf' }], criadoEm: dados.feitaEm, rotulo: 'Anexo — ' + S.aloj.name };
  toast('⏳ Enviando anexo...');
  enviarItem(item).then(function () {
    sync.err = null; updateSyncUI();
    toast('📎 Vistoria anexada e enviada para a gestão', 'success');
    showCompetenciaScreen();
  }).catch(function (e: any) {
    sync.err = e.message; updateSyncUI();
    alert('Não consegui enviar o anexo agora: ' + e.message + '\n\nTente de novo em um lugar com sinal melhor.');
  });
}

export function mudarComp() {
  const m = document.getElementById('comp-mes') as HTMLSelectElement, a = document.getElementById('comp-ano') as HTMLSelectElement;
  if (m && a) S.comp = { ano: parseInt(a.value, 10), mes: MESES.indexOf(m.value) + 1 };
  showCompetenciaScreen();
}
export function iniciarVistoria() {
  const m = document.getElementById('comp-mes') as HTMLSelectElement, a = document.getElementById('comp-ano') as HTMLSelectElement;
  if (m && a) S.comp = { ano: parseInt(a.value, 10), mes: MESES.indexOf(m.value) + 1 };
  const cat = _checklist.length ? _checklist : lsGet('cache_checklist');
  if (!cat || !cat.length) { toast('⚠️ Checklist indisponível sem conexão. Abra com internet uma vez.', 'error'); return; }
  S.itens = congelarChecklist(cat);
  showForm();
}

// FORM
export function showForm() {
  let catHtml = '';
  const grupos: { titulo: string; itens: ItemChecklist[] }[] = [];
  S.itens.forEach(function (it: ItemChecklist) { const g = grupos[grupos.length - 1]; if (g && g.titulo === it.categoria) g.itens.push(it); else grupos.push({ titulo: it.categoria, itens: [it] }); });
  grupos.forEach(function (cat) {
    let items = '';
    cat.itens.forEach(function (it) {
      const st = S.statuses[it.n] || {}; const s = st.s || '';
      const show = (s === 'NC' || s === 'OBS');
      items += '<div class="irow" id="r' + it.n + '">' +
        '<span class="inum">' + it.n + '</span>' +
        '<span class="iname">' + esc(it.descricao) + '</span>' +
        '<div class="sbtns">' +
        '<button class="sb c' + (s === 'C' ? ' on' : '') + '" onclick="setSt(' + it.n + ',\'C\')">C</button>' +
        '<button class="sb nc' + (s === 'NC' ? ' on' : '') + '" onclick="setSt(' + it.n + ',\'NC\')">NC</button>' +
        '<button class="sb na' + (s === 'NA' ? ' on' : '') + '" onclick="setSt(' + it.n + ',\'NA\')">NA</button>' +
        '<button class="sb obs' + (s === 'OBS' ? ' on' : '') + '" onclick="setSt(' + it.n + ',\'OBS\')">OBS</button>' +
        '</div></div>' +
        '<div id="obs' + it.n + '" style="display:' + (show ? 'block' : 'none') + ';padding:0 18px 10px">' +
        '<input type="text" placeholder="Observacao / acao corretiva..." value="' + esc(st.obs || '') + '" oninput="setObs(' + it.n + ',this.value)"></div>' +
        '<div id="ph' + it.n + '" style="display:' + (show ? 'block' : 'none') + ';padding:0 18px 10px">' +
        '<div id="phi' + it.n + '"></div></div>';
    });
    catHtml += '<div class="card"><div class="card-head">' + esc(cat.titulo) + '</div>' + items + '</div>';
  });
  const sc = notaAtual(), cl = classificar(sc), cor = COR_FORM[cl.faixa];
  (document.getElementById('app') as HTMLElement).innerHTML =
    '<div style="background:#060e1a;min-height:100%">' +
    '<div class="fhdr"><button class="fhdr-back" onclick="showObras()">←</button><div>' +
    '<div style="font-weight:800;font-size:14px">' + esc(S.aloj.name) + '</div>' +
    '<div style="font-size:10px;color:rgba(150,185,225,.5);text-transform:uppercase;letter-spacing:.4px">' + esc(S.obra.name) + '</div>' +
    '</div></div>' +
    '<div class="pb" style="max-width:600px;margin:0 auto">' +
    '<div class="card"><div class="card-head">📋 Dados</div><div class="card-body" style="display:grid;gap:10px">' +
    '<input type="text" placeholder="Responsavel / auditor *" value="' + esc(S.info.auditor) + '" oninput="S.info.auditor=this.value">' +
    '<input type="email" placeholder="Seu e-mail *" value="' + esc(S.info.email || '') + '" oninput="S.info.email=this.value">' +
    '<input type="text" placeholder="Endereco do alojamento" value="' + esc(S.info.addr) + '" oninput="S.info.addr=this.value">' +
    '</div></div>' +
    catHtml +
    '<div class="card"><div class="card-head">📸 Fotos do alojamento</div>' +
    '<div id="gen-grid" class="gen-grid"><div><div class="gen-add" onclick="pickGen()">+</div></div></div>' +
    '<div style="padding:0 18px 12px"><button class="padd" onclick="pickGen()" style="width:100%">📷 Selecionar várias fotos</button>' +
    '<div style="font-size:12px;color:#64748b;margin-top:6px">Dá para marcar várias de uma vez na galeria (até 20).</div></div></div>'
    + '<button onclick="doSubmit()" style="width:100%;background:linear-gradient(135deg,#1a3a70,#2E5C8A);border:1px solid rgba(255,255,255,.12);border-radius:14px;padding:16px 20px;color:#fff;cursor:pointer;font-family:inherit;text-align:left;display:flex;align-items:center;gap:14px;box-shadow:0 6px 20px rgba(31,56,100,.4);margin-top:4px">' +
    '<span style="font-size:22px">✅</span><div><div style="font-size:15px;font-weight:800">Enviar vistoria</div>' +
    '<div style="font-size:12px;color:rgba(200,220,248,.7)">Gera PDF e salva no sistema</div></div>' +
    '<span style="margin-left:auto;font-size:18px;color:rgba(255,255,255,.3)">›</span></button>' +
    '</div>' +
    '<div class="scorebar">' +
    '<div style="display:flex;align-items:center;gap:12px;max-width:600px;margin:0 auto">' +
    '<div style="flex:1;min-width:0">' +
    '<div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:5px">' +
    '<span style="font-size:10px;font-weight:700;color:rgba(140,170,210,.5);text-transform:uppercase;letter-spacing:1px">Pontuação</span>' +
    '<div><span id="sv" style="font-size:20px;font-weight:900;color:' + cor + '">' + sc.toFixed(1) + '%</span> ' +
    '<span id="sc" style="font-size:10px;font-weight:700;color:' + cor + ';text-transform:uppercase">' + cl.rotulo + '</span></div></div>' +
    '<div style="background:rgba(255,255,255,.08);border-radius:99px;height:5px;overflow:hidden">' +
    '<div id="sf" style="height:100%;border-radius:99px;width:' + sc + '%;background:' + cor + ';transition:width .4s"></div></div>' +
    '<div style="display:flex;justify-content:space-between;margin-top:4px">' +
    '<span style="font-size:10px;color:rgba(140,170,210,.4)">Itens respondidos</span>' +
    '<span id="ac" style="font-size:14px;font-weight:800;color:rgba(200,220,248,.8)">0 / ' + S.itens.length + '</span></div>' +
    '</div>' +
    '<button id="send-fixed" onclick="doSubmit()" style="background:linear-gradient(135deg,#16a34a,#15803d);border:none;border-radius:12px;padding:12px 15px;color:#fff;font-weight:800;font-size:14px;cursor:pointer;font-family:inherit;white-space:nowrap;box-shadow:0 4px 14px rgba(22,163,74,.45);flex-shrink:0">✅ Enviar</button>' +
    '</div></div>' +
    '</div>';
  S.itens.forEach(function (it: ItemChecklist) { const st = S.statuses[it.n]; if (st && (st.s === 'NC' || st.s === 'OBS')) refreshPh(it.n); });
  refreshGen();
  updateScore();
}

function respostasAtuais(): any {
  const r: any = {};
  Object.keys(S.statuses).forEach(function (k) { const st = S.statuses[k]; if (st && st.s) r[k] = { s: st.s, obs: st.obs || '' }; });
  return r;
}
/** Nota ao vivo: o mesmo motor do servidor, empacotado (decisão 7.2). */
function notaAtual(): number { return calcularNota(S.itens, respostasAtuais()); }

export function setSt(n: number, s: string) {
  if (!S.statuses[n]) S.statuses[n] = { s: null, obs: '' };
  S.statuses[n].s = (S.statuses[n].s === s) ? null : s;
  const ns = S.statuses[n].s;
  const row = document.getElementById('r' + n); if (!row) return;
  row.querySelectorAll('.sb').forEach(function (b) { b.classList.remove('on'); });
  if (ns) { const b = row.querySelector('.sb.' + ns.toLowerCase()); if (b) b.classList.add('on'); }
  const show = (ns === 'NC' || ns === 'OBS');
  const obsEl = document.getElementById('obs' + n); if (obsEl) obsEl.style.display = show ? 'block' : 'none';
  const phEl = document.getElementById('ph' + n); if (phEl) { phEl.style.display = show ? 'block' : 'none'; if (show) refreshPh(n); }
  updateScore();
}
export function setObs(n: number, v: string) { if (!S.statuses[n]) S.statuses[n] = { s: null, obs: '' }; S.statuses[n].obs = v; }
export function updateScore() {
  const sc = notaAtual(), cl = classificar(sc), cor = COR_FORM[cl.faixa] as string;
  const sv = document.getElementById('sv'); if (sv) { sv.textContent = sc.toFixed(1) + '%'; sv.style.color = cor; }
  const scEl = document.getElementById('sc'); if (scEl) { scEl.textContent = cl.rotulo; scEl.style.color = cor; }
  const sf = document.getElementById('sf'); if (sf) { sf.style.width = sc + '%'; sf.style.background = cor; }
  const ac = document.getElementById('ac');
  if (ac) ac.textContent = S.itens.filter(function (it: ItemChecklist) { return S.statuses[it.n] && S.statuses[it.n].s; }).length + ' / ' + S.itens.length;
}
export function refreshPh(n: number) {
  const el = document.getElementById('phi' + n); if (!el) return;
  const photos: string[] = S.itemPhotos[n] || [];
  let html = '<div style="display:flex;flex-wrap:wrap;gap:6px;margin-bottom:6px">';
  photos.forEach(function (ph, i) {
    html += '<div class="pthumb" style="position:relative;display:inline-block">'
      + '<img src="' + ph + '" style="width:72px;height:54px;object-fit:contain;background:#0f172a;border-radius:8px;border:1px solid #e2e8f0">'
      + '<button class="prm" onclick="rmPh(' + n + ',' + i + ')" style="position:absolute;top:-6px;right:-6px;background:#dc2626;border:none;border-radius:50%;width:18px;height:18px;color:#fff;font-size:12px;cursor:pointer;display:flex;align-items:center;justify-content:center;line-height:1">×</button>'
      + '</div>';
  });
  html += '</div>';
  html += '<button class="padd" onclick="pickPhotos(' + n + ')">📷 ' + (photos.length > 0 ? 'Adicionar mais fotos' : 'Selecionar foto(s) do defeito') + '</button>';
  el.innerHTML = html;
}
function addPh(n: number, b64arr: string[] | string) {
  if (!S.itemPhotos[n]) S.itemPhotos[n] = [];
  if (Array.isArray(b64arr)) { b64arr.forEach(function (b) { S.itemPhotos[n].push(b); }); }
  else S.itemPhotos[n].push(b64arr);
  refreshPh(n);
}
export function rmPh(n: number, i: number) { if (S.itemPhotos[n]) S.itemPhotos[n].splice(i, 1); refreshPh(n); }
export function pickPhotos(n: number) { pickMultiplePhotos(function (arr) { addPh(n, arr); }); }
const MAX_GEN = 20;
export function pickGen() {
  pickMultiplePhotos(function (arr) {
    const livre = MAX_GEN - S.genPhotos.length;
    if (livre <= 0) { toast('Limite de ' + MAX_GEN + ' fotos gerais atingido', 'error'); return; }
    if (arr.length > livre) {
      toast('Cabem mais ' + livre + ' foto(s) aqui — as demais não foram incluídas', 'error');
      arr = arr.slice(0, livre);
    }
    arr.forEach(function (b) { S.genPhotos.push(b); });
    refreshGen();
  });
}
export function rmGen(i: number) { S.genPhotos.splice(i, 1); refreshGen(); }
export function refreshGen() {
  const g = document.getElementById('gen-grid'); if (!g) return;
  let h = S.genPhotos.map(function (p: string, i: number) { return '<div><div class="pthumb" style="display:block"><img src="' + p + '" style="width:100%;height:72px;object-fit:contain;background:#0f172a"><button class="prm" onclick="rmGen(' + i + ')">x</button></div><div style="font-size:11px;color:#94a3b8;text-align:center;margin-top:3px">Foto ' + (i + 1) + '</div></div>'; }).join('');
  if (S.genPhotos.length < MAX_GEN) h += '<div><div class="gen-add" onclick="pickGen()">+</div></div>';
  g.innerHTML = h;
}

export async function doSubmit() {
  const erro = erroDoEnvio({ auditor: S.info.auditor, email: S.info.email });
  if (erro) { alert(erro); return; }
  const emailV = String(S.info.email || '').trim();
  const resp = respostasAtuais();
  const miss = S.itens.filter(function (it: ItemChecklist) { return !resp[it.n]; }).length;
  if (miss > 0 && !confirm(miss + ' item(s) sem preencher. Continuar?')) return;
  lsSet('lastEmail', emailV);
  const feitaEm = new Date().toISOString();
  const dados: EnvioVistoria = {
    idCliente: novoId(), alojId: S.aloj.id, competencia: compTxt(S.comp), semana: S.semana || null,
    auditor: S.info.auditor, email: emailV, endereco: S.info.addr || '', checklist: S.itens, respostas: resp, feitaEm,
  };
  const arquivos: { campo: string; blob: Blob; nome: string }[] = [];
  S.genPhotos.forEach(function (p: string, i: number) { arquivos.push({ campo: 'geral', blob: dataUrlParaBlob(p), nome: 'geral-' + (i + 1) + '.jpg' }); });
  Object.keys(S.itemPhotos).forEach(function (n) {
    (S.itemPhotos[n] || []).forEach(function (p: string, i: number) { arquivos.push({ campo: 'item_' + n, blob: dataUrlParaBlob(p), nome: 'item-' + n + '-' + (i + 1) + '.jpg' }); });
  });
  const item: ItemFila = { idCliente: dados.idCliente, rota: '/api/vistorias', dados, arquivos, criadoEm: feitaEm, rotulo: S.aloj.name + ' — ' + MESES[S.comp.mes - 1] + '/' + S.comp.ano };

  // PDF imediato com o que está na tela (funciona sem rede)
  const rel = relatorioLocal({
    enviadaEm: feitaEm, obraNome: S.obra.name, alojNome: S.aloj.name, responsavel: S.aloj.resp,
    competenciaRotulo: MESES[S.comp.mes - 1] + '/' + S.comp.ano, checklist: S.itens, respostas: resp,
    fotosItem: S.itemPhotos, fotosGerais: S.genPhotos.slice(),
  });
  _syncMsg = '<span style="color:#f0c060">&#9203; Enviando para a Area de Gestao...</span>';
  try { await adicionarNaFila(item); } catch (e) { console.warn('fila indisponível:', e); }
  buildPDF(rel);
  showSuccess(rel.nota, rel.faixa, rel.rotulo);
  enviarItem(item).then(function () {
    sync.err = null;
    _syncMsg = '<span style="color:#22c55e">&#9989; Recebida na Area de Gestao</span>';
    updateSyncUI();
  }).catch(function (e: any) {
    sync.err = e.message;
    _syncMsg = '<span style="color:#fbbf24">&#9203; Sem conexao no momento. A vistoria esta salva no aparelho e sera enviada sozinha assim que houver internet &mdash; mantenha o app instalado e abra-o de novo em area com sinal.</span>';
    updateSyncUI();
  });
}

// SUCCESS
function showSuccess(nota: number, faixa: string, rotulo: string) {
  const cor = COR_FORM[faixa];
  (document.getElementById('app') as HTMLElement).innerHTML =
    '<div style="min-height:100vh;background:#060e1a;display:flex;align-items:center;justify-content:center;padding:20px">'
    + '<div style="width:100%;max-width:360px;background:rgba(8,18,38,.85);backdrop-filter:blur(20px);border-radius:24px;border:1px solid rgba(22,163,74,.3);box-shadow:0 32px 64px rgba(0,0,0,.5);padding:36px 24px;text-align:center">'
    + '<div style="font-size:56px;margin-bottom:12px">✅</div>'
    + '<div style="font-weight:800;font-size:22px;color:#22c55e;margin-bottom:8px">Vistoria enviada!</div>'
    + '<div style="font-size:30px;font-weight:900;color:' + cor + ';margin:12px 0 4px">' + nota.toFixed(1) + '%</div>'
    + '<div style="font-size:12px;font-weight:700;color:' + cor + ';text-transform:uppercase;letter-spacing:.5px;margin-bottom:16px">' + rotulo + '</div>'
    + '<div style="font-size:13px;color:rgba(180,200,230,.6);margin-bottom:10px;line-height:1.6">&#10003; PDF gerado automaticamente<br><strong style="color:#C9A84C">Competência: ' + esc(MESES[S.comp.mes - 1] + '/' + S.comp.ano) + '</strong></div>'
    + '<div id="sync-state" style="font-size:12px;font-weight:700;line-height:1.5;margin-bottom:20px;background:rgba(255,255,255,.04);border-radius:10px;padding:10px 12px">' + (_syncMsg || '') + '</div>'
    + '<button onclick="renderHome()" class="btn btn-secondary">← Voltar ao inicio</button>'
    + '</div></div>';
}

export { enviarPendentes };
